import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { createContext, PropsWithChildren, useContext } from 'react';

import { getApolloState, initializeApollo } from '../apollo-utils/apollo';
import { useCreateNamedApolloClient } from '../apollo-utils/named-apollo-provider';

const CLIENT_NAME = '__SMART_SEARCH__';

export function initializeSmartSearchApolloClient(url: string) {
  return initializeApollo(CLIENT_NAME, url);
}

export function getSmartApolloClientState(
  client: ApolloClient<NormalizedCacheObject>
) {
  return getApolloState(CLIENT_NAME, client);
}

interface Props {
  url: string;
  pageProps: Record<string, unknown>;
}

const SmartSearchApolloContext =
  createContext<ApolloClient<NormalizedCacheObject> | null>(null);

export const SmartSearchApolloProvider: React.FC<
  Props & PropsWithChildren<unknown>
> = ({ url, pageProps, children }) => {
  const apolloClient = useCreateNamedApolloClient(CLIENT_NAME, url, pageProps);

  return (
    <SmartSearchApolloContext.Provider value={apolloClient}>
      {children}
    </SmartSearchApolloContext.Provider>
  );
};

export const useSmartSearchApolloClient = () => {
  const apolloClient = useContext(SmartSearchApolloContext);

  if (!apolloClient) {
    throw Error(`There is no apollo client defined for 'smart-search'.
            Perhaps you have forgotten to register it with a SmartSearchApolloProvider`);
  }

  return apolloClient;
};
